import React from "react";
import { Routes, Route } from "react-router-dom";
import { BoardAuthProvider, RequireAuth } from "./BoardAuth";
import BoardLayout from "./BoardLayout";
import Login from "./pages/Login";
import Cockpit from "./pages/Cockpit";
import Risks from "./pages/Risks";
import Compliance from "./pages/Compliance";
import Findings from "./pages/Findings";
import Meetings from "./pages/Meetings";
import Documents from "./pages/Documents";
import AuditTrail from "./pages/AuditTrail";
import Leads from "./pages/Leads";
import Settings from "./pages/Settings";

const BoardApp = () => (
  <BoardAuthProvider>
    <Routes>
      <Route path="/board/login" element={<Login />} />
      <Route path="/board" element={<RequireAuth><BoardLayout /></RequireAuth>}>
        <Route index element={<Cockpit />} />
        <Route path="risks" element={<Risks />} />
        <Route path="compliance" element={<Compliance />} />
        <Route path="findings" element={<Findings />} />
        <Route path="meetings" element={<Meetings />} />
        <Route path="documents" element={<Documents />} />
        <Route path="audit-trail" element={<AuditTrail />} />
        <Route path="leads" element={<Leads />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  </BoardAuthProvider>
);

export default BoardApp;
